import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { NgbDropdownModule, NgbNavModule, NgbPaginationModule, NgbTypeaheadModule, NgbHighlight, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AgGridModule } from 'ag-grid-angular';
import { ChargesRoutingModule } from './charges-routing.module';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { UploadComponent } from 'src/app/components/system-config/charges/upload/upload.component';  
import { ChargesService } from 'src/app/services/system-config/charges/charges.service';

import { AddChargesComponent } from 'src/app/components/system-config/charges/manage/add/add.component';
import { EditChargesComponent } from 'src/app/components/system-config/charges/manage/edit/edit.component';
import { ListChargesComponent } from 'src/app/components/system-config/charges/manage/list/list.component';
import { ToastrModule } from 'ngx-toastr';
import { GeoService } from 'src/app/services/geo.service';
import { CustomerService } from 'src/app/services/customer.service';
import { VendorService } from 'src/app/services/vendor.service';
import { ProductService } from 'src/app/services/products.service';
import { FuelSurchargesComponent } from 'src/app/components/system-config/charges/fuelsurcharges/fuelsurcharges.component';
import { ChargedetailsComponent } from 'src/app/components/system-config/charges/upload/details/chargedetails.component';  
import { ChargeperiodComponent } from 'src/app/components/system-config/charges/upload/periods/chargeperiod.component';  
import { RateBandsService } from 'src/app/services/ratebands.service';
import { ChargeWeightSlabsComponent } from 'src/app/components/system-config/charges/upload/slab-details/charge-weight-slabs.component';
import { ODAChargesComponent } from 'src/app/components/system-config/charges/oda/oda.component';


@NgModule({
    declarations: [
        ChargeWeightSlabsComponent,
        ChargedetailsComponent,
        ChargeperiodComponent,
        UploadComponent,
        ListChargesComponent,
        AddChargesComponent,
        EditChargesComponent,
        FuelSurchargesComponent,
        ODAChargesComponent,
    ],
    imports: [
        CommonModule,
        ChargesRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        NgbHighlight,
        NgbNavModule,
        NgbDropdownModule,
        NgbTypeaheadModule,
        NgbPaginationModule,
        NgSelectModule,
        AgGridModule,
        NgMultiSelectDropDownModule,
        ToastrModule,
        NgbModule
    ],
    exports: [
        ChargeWeightSlabsComponent,
        ChargedetailsComponent,
        ChargeperiodComponent,
        UploadComponent,
        ListChargesComponent,
        AddChargesComponent,
        EditChargesComponent,
        FuelSurchargesComponent,
        ODAChargesComponent,
    ],
    providers: [
        GeoService,
        CustomerService,
        VendorService,
        ProductService,
        ChargesService,
        RateBandsService
    ]
})
export class ChargesModule { }
